import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// API
import * as ChannelApi from "../../api/apis/ChannelApi";
import {VenueDto} from "../../api/models/VenueDto";

// Components
import VenueListComponent from "../../components/Venues/VenueList";

import * as Utils from "../../utils";

interface RouteParams {
  channelid: string;
}

const VenueListLayout: React.FC<any> = (props: any) => {
  const [venues, setVenues] = useState<VenueDto[]>([]);
  const [time, setTime] = useState<number>(Date.now);
  const [refresh, setRefresh] = useState<number>(new Date().getTime());
  let params = useParams<RouteParams>();

  // Refresh page
  useEffect(() => {
    let interval = setInterval(
      () => setTime(Date.now()),
      Utils.RefreshInterval
    );

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Get channel
  useEffect(() => {
    let channelId: string = params.channelid;
    let channelApi = new ChannelApi.ChannelApi();
    channelApi
      .getChannelVenues({ channelId: channelId })
      .then((response: any) => {
        setVenues((venues: VenueDto[]) => venues = response.data);
      })
      .catch((response) => {
        Utils.showError(props.setAlert, response);
      });
  }, [time, refresh]);

  return (
    <div>
      <VenueListComponent
        channelId={params.channelid}
        venues={venues}
        setRefresh={setRefresh}
      />
    </div>
  );
};

export default VenueListLayout;
